export default __webpack_public_path__ + "static/media/DinosaursFlyingRetiples_06.5db1b38c.png";